import React from 'react'
import { Radio, Button } from 'antd'
import { MetadataOption } from '../../api/index'
import { appOption } from '../../utils/index'

interface RadiosOptions {
	label: string
	value: string
}

export interface AppButtonProps {
	label?: string
	onClick?: (e: any) => void
	readonly?: boolean
	type?: 'link' | 'ghost' | 'default' | 'primary' | 'dashed' | 'danger'
}

export default function AppButton(props: AppButtonProps) {
	return (
		<div title={props.label}>
			<Button onClick={props.onClick} className="app-form-button-new" type={props.type}>
				{props.label}
			</Button>
		</div>
	)
}



// WEBPACK FOOTER //
// ./src/components/AppFormItem/AppButton.tsx